import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/p/$projectKey/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/p/$projectKey/settings/general', params });
  },
});
